import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	touchKeyboardEnabled: Boolean(JSON.parse(localStorage.getItem('pos_touch_keyboard_enabled') || 'false')),
	showTouchKeyboard: false,
	activeModal: null,
	activeTab: 'dine-in',
	showMenuPopup: false,
	selectedTableId: null,
};

const posUISlice = createSlice({
	name: 'posUI',
	initialState,
	reducers: {
		toggleTouchKeyboard: (state) => {
			state.touchKeyboardEnabled = !state.touchKeyboardEnabled;
			localStorage.setItem('pos_touch_keyboard_enabled', JSON.stringify(state.touchKeyboardEnabled));
		},
		setShowTouchKeyboard: (state, action) => {
			state.showTouchKeyboard = Boolean(action.payload);
		},
		setActiveModal: (state, action) => {
			state.activeModal = action.payload || null;
		},
		setActiveTab: (state, action) => {
			state.activeTab = action.payload || 'dine-in';
		},
		setShowMenuPopup: (state, action) => {
			state.showMenuPopup = Boolean(action.payload);
		},
		setSelectedTableId: (state, action) => {
			state.selectedTableId = action.payload || null;
		},
	},
});

export const { toggleTouchKeyboard, setShowTouchKeyboard, setActiveModal, setActiveTab, setShowMenuPopup, setSelectedTableId } = posUISlice.actions;
export default posUISlice.reducer;


